// src/tabs/SitesTab.js

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, message, Modal, Form, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import GenericTable from "../components/GenericTable";
import {
  fetchKbSitesRequest,
  addKbSiteRequest,
  deleteKbSiteRequest,
  fetchSiteContentRequest,
} from "../redux-saga/actions/knowledgeBaseActions";

const SitesTab = ({ knowledgeBaseId }) => {
  const dispatch = useDispatch();
  const sites = useSelector((state) => state.knowledgeBase.sites[knowledgeBaseId] || []);
  const loading = useSelector((state) => state.knowledgeBase.loading);

  const [siteModalVisible, setSiteModalVisible] = useState(false);
  const [siteViewModalVisible, setSiteViewModalVisible] = useState(false);
  const [selectedSiteData, setSelectedSiteData] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(fetchKbSitesRequest(knowledgeBaseId));
  }, [dispatch, knowledgeBaseId]);

  const handleViewSite = (siteId) => {
    dispatch(fetchSiteContentRequest(siteId)).then((response) => {
      setSelectedSiteData(response.payload);
      setSiteViewModalVisible(true);
    });
  };

  const handleDeleteSite = (siteId) => {
    dispatch(deleteKbSiteRequest(siteId)).then(() => {
      message.success("Site deleted successfully!");
      dispatch(fetchKbSitesRequest(knowledgeBaseId));
    });
  };

  const handleAddSite = (values) => {
    dispatch(addKbSiteRequest({ link: values.siteUrl, knowledgeBaseId })).then(() => {
      message.success("Site added successfully!");
      setSiteModalVisible(false);
      form.resetFields();
      dispatch(fetchKbSitesRequest(knowledgeBaseId));
    });
  };

  const siteActions = ["View", "Delete"];
  const siteActionFunctions = [
    (record) => handleViewSite(record.id),
    (record) => handleDeleteSite(record.id),
  ];

  const columnsConfig = [
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      sortable: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sortable: true,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      sortable: true,
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sortable: true,
      render: (text) => new Date(text).toLocaleString(),
    },
  ];

  return (
    <div>
       <div style={{display:"flex",justifyContent:"end"}}>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setSiteModalVisible(true)}>
        Add New Site
      </Button>
      </div>
      <GenericTable
        data={sites}
        columnsConfig={columnsConfig}
        searchKeys={["link", "status"]}
        actions={siteActions}
        actionFunctions={siteActionFunctions}
        defaultPageSize={10}
        rowKey="id"
      />

      <Modal
        title="Add New Site"
        visible={siteModalVisible}
        onCancel={() => setSiteModalVisible(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleAddSite}>
          <Form.Item
            name="siteUrl"
            label="Site URL"
            rules={[{ required: true, message: "Please enter site URL" }]}
          >
            <Input placeholder="Enter site URL" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Site Details"
        visible={siteViewModalVisible}
        onCancel={() => setSiteViewModalVisible(false)}
        footer={null}
        width={800}
      >
        {selectedSiteData ? (
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <pre style={{ whiteSpace: "pre-wrap" }}>{selectedSiteData.content}</pre>
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </div>
  );
};

export default SitesTab;
